module.exports = require("zingtouch");